import { render } from "./TCFooter.vue?vue&type=template&id=4262c893&scoped=true"
import script from "./TCFooter.vue?vue&type=script&lang=js"
export * from "./TCFooter.vue?vue&type=script&lang=js"

import "./TCFooter.vue?vue&type=style&index=0&id=4262c893&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tunescrib-rs/tunescrib-rs/dev.tunescrib.com-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4262c893"]])

export default __exports__